import React from 'react';
import { MessageSquareIcon, TargetIcon, LightbulbIcon, HeadphonesIcon } from 'lucide-react';
type ProcessStep = {
  icon: React.ReactNode;
  number: string;
  title: string;
  description: string;
};
export function Process() {
  return <section className="py-24 bg-white" aria-labelledby="process-title" data-id="element-175">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-176">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-177">
          <p className="section-label" data-id="element-178">How We Work</p>
          <h2 id="process-title" className="section-title" data-id="element-179">
            Our Consulting Process
          </h2>
          <p className="text-[#6B6B6B] max-w-xl mx-auto text-base leading-relaxed" data-id="element-180">
            A structured, proven approach to delivering measurable results for
            every client engagement.
          </p>
        </div>

        {/* Steps */}
        <div className="relative" data-id="element-181">
          {/* Connecting line (desktop only) */}
          <div className="hidden md:block absolute top-10 left-[12.5%] right-[12.5%] h-0.5" style={{
          backgroundColor: '#3A9A6A',
          opacity: 0.2
        }} aria-hidden="true" data-id="element-182" />

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-6" data-id="element-183">
            {/* Step 1 */}
            <div className="flex flex-col items-center text-center relative" data-id="element-184">
              <div className="w-20 h-20 rounded-full flex items-center justify-center mb-5 relative z-10" style={{
              backgroundColor: '#3A9A6A1A',
              border: '2px solid #3A9A6A30'
            }} data-id="element-185">
                <MessageSquareIcon size={28} color="#3A9A6A" aria-hidden="true" data-id="element-186" />
              </div>
              <span className="text-xs font-bold tracking-widest text-[#3A9A6A] mb-2" data-id="element-187">
                01
              </span>
              <h3 className="text-lg font-bold text-[#3C3C3C] mb-2" data-id="element-188">
                Consultation
              </h3>
              <p className="text-sm text-[#6B6B6B] leading-relaxed" data-id="element-189">
                We begin with a thorough discovery session to understand your
                business needs and goals.
              </p>
            </div>

            {/* Step 2 */}
            <div className="flex flex-col items-center text-center relative" data-id="element-190">
              <div className="w-20 h-20 rounded-full flex items-center justify-center mb-5 relative z-10" style={{
              backgroundColor: '#3A9A6A1A',
              border: '2px solid #3A9A6A30'
            }} data-id="element-191">
                <TargetIcon size={28} color="#3A9A6A" aria-hidden="true" data-id="element-192" />
              </div>
              <span className="text-xs font-bold tracking-widest text-[#3A9A6A] mb-2" data-id="element-193">
                02
              </span>
              <h3 className="text-lg font-bold text-[#3C3C3C] mb-2" data-id="element-194">
                Strategy
              </h3>
              <p className="text-sm text-[#6B6B6B] leading-relaxed" data-id="element-195">
                We develop a tailored strategic plan aligned with your
                objectives and resources.
              </p>
            </div>

            {/* Step 3 */}
            <div className="flex flex-col items-center text-center relative" data-id="element-196">
              <div className="w-20 h-20 rounded-full flex items-center justify-center mb-5 relative z-10" style={{
              backgroundColor: '#3A9A6A1A',
              border: '2px solid #3A9A6A30'
            }} data-id="element-197">
                <LightbulbIcon size={28} color="#3A9A6A" aria-hidden="true" data-id="element-198" />
              </div>
              <span className="text-xs font-bold tracking-widest text-[#3A9A6A] mb-2" data-id="element-199">
                03
              </span>
              <h3 className="text-lg font-bold text-[#3C3C3C] mb-2" data-id="element-200">
                Advisory
              </h3>
              <p className="text-sm text-[#6B6B6B] leading-relaxed" data-id="element-201">
                Expert guidance and recommendations are delivered throughout the
                engagement.
              </p>
            </div>

            {/* Step 4 */}
            <div className="flex flex-col items-center text-center relative" data-id="element-202">
              <div className="w-20 h-20 rounded-full flex items-center justify-center mb-5 relative z-10" style={{
              backgroundColor: '#3A9A6A1A',
              border: '2px solid #3A9A6A30'
            }} data-id="element-203">
                <HeadphonesIcon size={28} color="#3A9A6A" aria-hidden="true" data-id="element-204" />
              </div>
              <span className="text-xs font-bold tracking-widest text-[#3A9A6A] mb-2" data-id="element-205">
                04
              </span>
              <h3 className="text-lg font-bold text-[#3C3C3C] mb-2" data-id="element-206">Support</h3>
              <p className="text-sm text-[#6B6B6B] leading-relaxed" data-id="element-207">
                Ongoing support ensures successful implementation and continued
                progress.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}